import { deleteData, getData, postData, putData } from "./APIServiceInterface";

export const getToolsOfferedService = async (payload) => {
  const response = await getData(`/toolsOffered/getBySalesOffice?salesOfficeId=${payload}`);
  return response;
};

export const createNewToolService = async (payload) => {
  const response = await putData("/toolsOffered/create", payload);
  return response;
};

export const updateToolService = async (id, payload) => {
  return await postData(`/toolsOffered/update?toolsOfferedId=${id}`, payload);
};

export const deleteToolService = async (payload) => {
  return await deleteData(`/toolsOffered/delete?toolsOfferedId=${payload}`);
};

export const getBulkEmailContents = async(toolOffered) => {
  return await getData(`email/getBulkEmailMailContent?toolOfferedId=${toolOffered.toolsOfferedId}&userEmail=${localStorage.getItem("userEmailAddress")}`)
}

export const getBulkEmailSendToUser = async(payload) => {
  return await postData(`email/sendBulkEmail?toolOfferedId=${payload.toolsOfferedId}&userEmail=${localStorage.getItem("userEmailAddress")}`)
}